export const pathToPageName = {
  "/login": "Login Page",
  "/register": "Register Page",
  "/forgot-password": "Forgot Password Page",
  "/watch/:videoId": "Video Page",
  "/settings/:tabId": "Settings Page",
  "/link": "Link Page"
};
